import { useEffect, useState } from "react";

export default function ImageWithDimensions({ urlImage }) {
  const [imagesInfo, setImagesInfo] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (typeof urlImage !== "string" || urlImage.trim() === "") return;

    let parsedUrls = [];

    try {
      const result = JSON.parse(urlImage);
      if (Array.isArray(result)) {
        parsedUrls = result;
      } else if (typeof result === "string") {
        parsedUrls = [result];
      }
    } catch (error) {
      console.warn("Invalid JSON passed to ImageWithDimensions. Trying fallback parsing...");

      parsedUrls = urlImage
        .split(/(?=https?:\/\/)/g)
        .map((u) => u.trim())
        .filter((u) => u.match(/\.(jpg|jpeg|png|webp|gif)$/i));
    }

    if (parsedUrls.length === 0) {
      setImagesInfo([]);
      setLoading(false);
      return;
    }

    const loadImages = async () => {
      setLoading(true);
      const results = await Promise.all(
        parsedUrls.map(
          (url) =>
            new Promise((resolve) => {
              const img = new window.Image();
              img.src = url;

              img.onload = () => {
                resolve({
                  url,
                  width: img.width,
                  height: img.height,
                  loaded: true,
                });
              };

              img.onerror = () => {
                resolve({
                  url,
                  width: 0,
                  height: 0,
                  loaded: false,
                });
              };
            })
        )
      );

      setImagesInfo(results);
      setLoading(false);
    };

    loadImages();
  }, [urlImage]);

  const getLegibilityStatus = (width, height) => {
  if (width <= 400 || height <= 400) return "🔴 Não legível";
  if (width <= 720 || height <= 720) return "🟠 Legibilidade média";
  if (width >= 1000 && height >= 1000) return "🟢 Legibilidade ótima";
    return "⚪ Indisponível";
  };

  return (
    <div>
      {loading ? (
        <p><strong>Carregando informações...</strong></p>
      ) : (
        <>
          <p><strong>Total de imagens:</strong> {imagesInfo.length}</p>
          {imagesInfo.map((img, index) => (
            <div key={index}>
              <p>
                <strong>Imagen {index + 1}:</strong>
                {img.loaded
                  ? ` ${getLegibilityStatus(img.width, img.height)}`
                  : " ⚪ Indisponível"}
              </p>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
